import { render, staticRenderFns } from "./BlockSpace.vue?vue&type=template&id=256159bd"
import script from "./BlockSpace.vue?vue&type=script&lang=js"
export * from "./BlockSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports